module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0xiv-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 1. Map of South and Southeast Asia, including quake epicenter and the main tsunami-affected countries around the Indian Ocean basin.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00xv-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 2. Map of Sri Lanka’s main cities; additional towns are shown on the southwest coast."), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1435d98e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 84
// module chunks = 0